import { defineMessages } from 'react-intl';

export default defineMessages({
  noAccess: {
    id: 'app.components.BackToCompanySettings.noAccess',
    defaultMessage:
      'You do not have access to this page. Contact your account admin for permission.',
  },
});
